import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
// Material imports
import withStyles from "@mui/styles/withStyles";
class FadeUp extends PureComponent {
  render() {
    const {
      classes,
      children,
      shouldAnimate
    } = this.props;
    return /*#__PURE__*/React.createElement(CSSTransition, {
      timeout: 400,
      classNames: {
        appear: classes.appear,
        appearActive: classes.appearActive
      },
      in: true,
      appear: shouldAnimate
    }, children);
  }
}
const styles = {
  appear: {
    opacity: 0.5,
    transform: "translateY(25%)"
  },
  appearActive: {
    opacity: 1,
    transform: "translateY(0%)",
    transition: "all 400ms ease"
  }
};
export default withStyles(styles)(FadeUp);
FadeUp.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool
};
FadeUp.defaultProps = {
  shouldAnimate: true
};